import React from 'react';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Cart from '../components/Cart/Cart';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CartPage = () => {
  return ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Heading, null, "Warenkorb"), ___EmotionJSX(Spacer, null), ___EmotionJSX(Cart, null), ___EmotionJSX(Spacer, null));
};
export default CartPage;